module.exports = __webpack_public_path__ + "static/img/mute_camera.411855b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/mute_camera.png
// module id = WLyp
// module chunks = 24